import Checkbox from './Checkbox';
import TextArea from './TextArea';
import Select from './Select';
import Input from './Input';

export const jsonSchema = {};

export const widgets = {
    select: Select,
    input: Input,
    textarea: TextArea,
    checkbox: Checkbox
};

export const customUiSchema = {
    firstName: {
        'ui:widget': 'input'
    },
    lastName: {
        'ui:widget': 'input'
    },
    email: {
        format: 'email',
        'ui:widget': 'input'
    },
    secondaryEmail: {
        format: 'email',
        'ui:widget': 'input'
    }
};



/** WEBPACK FOOTER **
 ** ./src/ApplicationForm/schema.js
 **/